import React, {Fragment} from 'react';
import './UnitTypesTable.css';
import '../TokensToolbar/NewUnitToolbar/SelectedUnitStats/SelectedUnitStats.css';
import UNIT_TYPES from '../../configs/units';
import {UNIT_D4_MAX_SHOOTING_RANGE} from '../../constants/units';
import {MINUS_SIGN} from '../../constants/text';

/**
 * Таблица характеристик типов отрядов: строка на тип, колонки-характеристики
 * включаются флагами. Используется на странице правил «Отряды» (полный набор
 * колонок) и в обучающей модалке «Типы отрядов» (сокращенный набор, с
 * подписями типов).
 *
 * Ассеты статичных иконок отрядов: "unit_d6" -> "unit d6 friend.png"
 * (единственное отличие id от имени файла — подчеркивание вместо пробела)
 */
export const getUnitFriendIconSrc = (unitTypeId) => `/img/icons/${unitTypeId.replace('_', ' ')} friend.png`;

const UnitTypesTable = ({
  unitTypes,
  showName = false,
  showPrice = true,
  showSizePrice = true,
  showSpeed = true,
  showShootingRange = true,
  showMaxSize = true,
}) => {
  // Порядок типов — как в тулбаре найма (порядок объявления в UNIT_TYPES)
  const rows = unitTypes || Object.values(UNIT_TYPES);

  const statColumns = [
    showMaxSize && {
      key: 'maxSize',
      src: '/img/icons/unit size.png',
      label: 'Предельный размер',
      textClassName: 'text-black',
      getValue: (unitType) => unitType.maxSize,
    },
    showPrice && {
      key: 'price',
      src: '/img/icons/coins.png',
      label: 'Цена найма',
      textClassName: 'text-coins-dark',
      getValue: (unitType) => unitType.price,
    },
    showSizePrice && {
      key: 'sizePrice',
      src: '/img/icons/coins.png',
      label: 'Цена +1 размера',
      textClassName: 'text-coins-dark',
      getValue: (unitType) => unitType.sizePrice,
    },
    showSpeed && {
      key: 'speed',
      src: '/img/icons/speed.png',
      label: 'Дальность перемещения',
      textClassName: 'text-controls',
      getValue: (unitType) => unitType.speed,
    },
    showShootingRange && {
      key: 'shootingRange',
      src: '/img/icons/shooting.png',
      label: 'Дальность стрельбы',
      textClassName: 'text-war',
      getValue: (unitType) => (
        unitType.id === UNIT_TYPES.D4.id ? UNIT_D4_MAX_SHOOTING_RANGE : MINUS_SIGN
      ),
    },
  ].filter(Boolean);

  // Колонка подписи растягивается, колонки характеристик — равной ширины
  const gridTemplateColumns = [
    ...(showName ? ['minmax(0, 1.7fr)'] : []),
    'minmax(0, 1fr)',
    ...statColumns.map(() => 'minmax(0, 1fr)'),
  ].join(' ');

  return (
    <div className={'unit-types-table'} style={{gridTemplateColumns}}>
      {showName && <div className={'new-units-toolbar_stat-cell'}/>}
      <div className={'new-units-toolbar_stat-cell'}/>
      {statColumns.map((column) => (
        <img
          key={column.key}
          className={'new-units-toolbar_stat-cell_stat-img'}
          src={column.src}
          alt={column.label}
          title={column.label}
        />
      ))}

      {rows.map((unitType) => (
        <Fragment key={unitType.id}>
          {showName && (
            <div className={'unit-types-table_name'}>{unitType.description}</div>
          )}
          <img
            className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
            src={getUnitFriendIconSrc(unitType.id)}
            alt={unitType.description}
            title={unitType.description}
          />
          {statColumns.map((column) => (
            <div key={column.key} className={`new-units-toolbar_stat-cell_text ${column.textClassName}`}>
              {column.getValue(unitType)}
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};

export default UnitTypesTable;
